"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6426],{

/***/ 30469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qM": function() { return /* binding */ cacheImage; },
  "af": function() { return /* binding */ canDoAksiNyata; },
  "Et": function() { return /* binding */ determineBadge; },
  "sS": function() { return /* binding */ determineJenjangByEmail; },
  "h6": function() { return /* binding */ determineTopicState; },
  "ds": function() { return /* binding */ downloadImageFromUrl; },
  "LR": function() { return /* binding */ isActivityComplete; },
  "J8": function() { return /* binding */ shouldHideNav; }
});

// UNUSED EXPORTS: determineTopicStateByList, getCertificateAssets

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(32407);
// EXTERNAL MODULE: ./types/microlearning.ts
var microlearning = __webpack_require__(69384);
;// CONCATENATED MODULE: ./api/microlearning/types.ts
var JenjangValid;
(function(JenjangValid) {
    JenjangValid["SLB"] = "slb";
    JenjangValid["PAUD"] = "paud";
    JenjangValid["SD"] = "sd";
    JenjangValid["SMP"] = "smp";
    JenjangValid["SMK"] = "smk";
    JenjangValid["SMA"] = "sma";
    JenjangValid["NONJENJANG"] = "";
})(JenjangValid || (JenjangValid = {}));

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/helper.tsx





var isActivityComplete = function(contents, quiz) {
    var isComplete = true;
    contents.forEach(function(content) {
        if (content.completed === false) {
            isComplete = false;
        }
    });
    if (typeof quiz === "boolean") {
        return isComplete && quiz;
    }
    return isComplete && quiz.completed;
};
var canDoAksiNyata = function(modules) {
    return modules.length > 0 && !modules.some(function(module) {
        return module.postTest !== "passed";
    });
};
function determineTopicState(progress) {
    var ref;
    if ((progress === null || progress === void 0 ? void 0 : (ref = progress.modules) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
        var untouchModules = progress === null || progress === void 0 ? void 0 : (ref1 = progress.modules) === null || ref1 === void 0 ? void 0 : ref1.filter(function(module) {
            return !module.material;
        });
        var halfFinishedModule = progress === null || progress === void 0 ? void 0 : (ref2 = progress.modules) === null || ref2 === void 0 ? void 0 : ref2.filter(function(module) {
            var isPostTestNotPassed = typeof module.postTest === "boolean" ? !module.postTest : module.postTest !== microlearning/* PostTestStatus.Passed */.fs.Passed;
            return !!module.material && isPostTestNotPassed;
        });
        var finishedModules = progress === null || progress === void 0 ? void 0 : (ref3 = progress.modules) === null || ref3 === void 0 ? void 0 : ref3.filter(function(module) {
            return typeof module.postTest === "boolean" ? !!module.postTest : module.postTest === microlearning/* PostTestStatus.Passed */.fs.Passed;
        });
        if (untouchModules.length === (progress === null || progress === void 0 ? void 0 : (ref4 = progress.modules) === null || ref4 === void 0 ? void 0 : ref4.length)) {
            return "DEFAULT";
        }
        if ((halfFinishedModule.length > 0 || finishedModules.length > 0) && finishedModules.length < (progress === null || progress === void 0 ? void 0 : (ref5 = progress.modules) === null || ref5 === void 0 ? void 0 : ref5.length)) {
            return "MODULE_ON_PROGRESS";
        }
        if (finishedModules.length === (progress === null || progress === void 0 ? void 0 : (ref6 = progress.modules) === null || ref6 === void 0 ? void 0 : ref6.length) && (progress === null || progress === void 0 ? void 0 : (ref7 = progress.aksiNyata) === null || ref7 === void 0 ? void 0 : ref7.state) === "NOT_CREATED") {
            return "MODULE_DONE";
        }
        if ((progress === null || progress === void 0 ? void 0 : (ref8 = progress.aksiNyata) === null || ref8 === void 0 ? void 0 : ref8.state) === "CREATED") {
            return "AKSI_NYATA_CREATED";
        }
        if ((progress === null || progress === void 0 ? void 0 : (ref9 = progress.aksiNyata) === null || ref9 === void 0 ? void 0 : ref9.state) === "CONFIRMED") {
            return "AKSI_NYATA_ON_PROGRESS";
        }
        if ((progress === null || progress === void 0 ? void 0 : (ref10 = progress.aksiNyata) === null || ref10 === void 0 ? void 0 : ref10.state) === "NEED_REVISION") {
            return "AKSI_NYATA_NEED_REVISION";
        }
        if ((progress === null || progress === void 0 ? void 0 : (ref11 = progress.aksiNyata) === null || ref11 === void 0 ? void 0 : ref11.state) === "APPEAL") {
            return "AKSI_NYATA_APPEAL";
        }
        if ((progress === null || progress === void 0 ? void 0 : (ref12 = progress.aksiNyata) === null || ref12 === void 0 ? void 0 : ref12.state) === "COMPLETED") {
            return "AKSI_NYATA_DONE";
        }
        if ((progress === null || progress === void 0 ? void 0 : (ref13 = progress.aksiNyata) === null || ref13 === void 0 ? void 0 : ref13.state) === "VALIDATED") {
            return "AKSI_NYATA_VALIDATED";
        }
    }
    return "DEFAULT";
}
function determineTopicStateByList(topic) {
    var untouchedModules = topic.percentage === 0;
    var halfFinishedModules = topic.percentage > 0 && topic.percentage < 100;
    var finishedModules = topic.percentage === 100;
    if (untouchedModules) {
        return "DEFAULT";
    }
    if (halfFinishedModules) {
        return "MODULE_ON_PROGRESS";
    }
    if (finishedModules && topic.aksiNyataState === "NOT_CREATED") {
        return "MODULE_DONE";
    }
    if (topic.aksiNyataState === "CREATED") {
        return "AKSI_NYATA_CREATED";
    }
    if (topic.aksiNyataState === "CONFIRMED") {
        return "AKSI_NYATA_ON_PROGRESS";
    }
    if (topic.aksiNyataState === "NEED_REVISION") {
        return "AKSI_NYATA_NEED_REVISION";
    }
    if (topic.aksiNyataState === "APPEAL") {
        return "AKSI_NYATA_APPEAL";
    }
    if (topic.aksiNyataState === "COMPLETED") {
        return "AKSI_NYATA_DONE";
    }
    if (topic.aksiNyataState === "VALIDATED") {
        return "AKSI_NYATA_VALIDATED";
    }
    return "DEFAULT";
}
function determineBadge(topic) {
    var topicProgressState = determineTopicStateByList(topic);
    switch(topicProgressState){
        default:
            return undefined;
        case "MODULE_ON_PROGRESS":
            return {
                type: "informational",
                text: "Pelajari Modul"
            };
        case "MODULE_DONE":
        case "AKSI_NYATA_CREATED":
        case "AKSI_NYATA_ON_PROGRESS":
            return {
                type: "informational",
                text: "Praktikkan Aksi Nyata",
                state: "ongoing"
            };
        case "AKSI_NYATA_NEED_REVISION":
            return {
                type: "warning",
                text: "Butuh perbaikan Aksi Nyata",
                state: "ongoing"
            };
        case "AKSI_NYATA_DONE":
            return {
                type: "neutral",
                text: "Menunggu hasil validasi",
                state: "completed"
            };
        case "AKSI_NYATA_APPEAL":
            return {
                type: "neutral",
                text: "Menunggu hasil banding",
                state: "completed"
            };
        case "AKSI_NYATA_VALIDATED":
            if (!topic.certifiable) {
                return {
                    type: "neutral",
                    text: "Menunggu hasil validasi",
                    state: "completed"
                };
            }
            return {
                type: "success",
                text: "Sertifikat tersedia",
                state: "validated"
            };
    }
}
var downloadImageFromUrl = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var url, mime, _filename, filename, onError, onSuccess, _asNewTab, asNewTab, anchor, response, blob, objURL, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.url, mime = param.mime, _filename = param.filename, filename = _filename === void 0 ? "" : _filename, onError = param.onError, onSuccess = param.onSuccess, _asNewTab = param.asNewTab, asNewTab = _asNewTab === void 0 ? true : _asNewTab;
                    anchor = document.createElement("a");
                    if (asNewTab) {
                        anchor.setAttribute("href", url);
                        anchor.setAttribute("download", "".concat(filename, ".").concat(mime));
                        anchor.setAttribute("target", "_blank");
                        anchor.click();
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.blob()
                    ];
                case 3:
                    blob = _state.sent();
                    objURL = URL.createObjectURL(blob);
                    anchor.setAttribute("href", objURL);
                    anchor.setAttribute("download", "".concat(filename, ".").concat(mime));
                    anchor.click();
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    onError === null || onError === void 0 ? void 0 : onError(error);
                    (0,esm_exports/* captureException */.Tb)(error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function downloadImageFromUrl(_) {
        return _ref.apply(this, arguments);
    };
}();
var getCertificateAssets = function() {
    if (false) {}
    return {
        background: "https://storage.googleapis.com/microlearning-public-production/certificate-front-page/background.jpg",
        logo: "https://storage.googleapis.com/microlearning-public-production/certificate-front-page/logo.png"
    };
};
var VALID_JENJANG = [
    JenjangValid.PAUD,
    JenjangValid.SD,
    JenjangValid.SMP,
    JenjangValid.SMA,
    JenjangValid.SMK,
    JenjangValid.SLB, 
];
var determineJenjangByEmail = function(email) {
    var subdomain = email.split("@")[1] // ['putra.prawira', 'admin.sma.belajar.id'], results in 'admin.sma.belajar.id'
    ;
    if (!Boolean(subdomain)) return JenjangValid.NONJENJANG;
    var subdomainItems = subdomain.split(".")// ['admin', 'sma', 'belajar', 'id']
    ;
    var ref;
    return (ref = subdomainItems.find(function(item) {
        return VALID_JENJANG.includes(item);
    })) !== null && ref !== void 0 ? ref : JenjangValid.NONJENJANG // 'sma'
    ;
};
var shouldHideNav = function() {
    if (false) {}
    var query = location === null || location === void 0 ? void 0 : location.search;
    return query.includes("hide_nav=true");
};
var cacheImage = function(url) {
    var listStorage = [
        "https://storage.googleapis.com/microlearning-public-staging",
        "https://storage.googleapis.com/microlearning-public-production", 
    ];
    var newUrl = url.replace(listStorage.find(function(storage) {
        return url.includes(storage);
    }), "https://mil-kv.guru.belajar.id");
    return newUrl;
};


/***/ }),

/***/ 55312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Materi_MateriCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(68430);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/toast/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(55086);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var icon_dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/helper.tsx + 1 modules
var helper = __webpack_require__(30469);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
// EXTERNAL MODULE: ./utils/text.ts + 1 modules
var utils_text = __webpack_require__(40999);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/CheckmarkNoFill.tsx
var CheckmarkNoFill = __webpack_require__(10854);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Materi/ActivityItem.tsx











var ActivityItem = function(param) {
    var type = param.type, name = param.name, href = param.href, _isComplete = param.isComplete, isComplete = _isComplete === void 0 ? false : _isComplete, _isShouldRetry = param.isShouldRetry, isShouldRetry = _isShouldRetry === void 0 ? false : _isShouldRetry, _trackingParams = param.trackingParams, trackingParams = _trackingParams === void 0 ? {} : _trackingParams, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("flex items-center w-full mb-3 last:mb-0", isActive && "bg-[#0B5FEF] p-2 rounded-lg"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("relative flex-shrink-0 flex-grow-0 flex items-center justify-center w-6 h-4 rounded-full z-10", !isActive && "bg-white "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkNoFill/* default */.Z, {
                    width: 17,
                    height: 16,
                    size: "sm",
                    className: (0,clsx_m/* default */.Z)(!isComplete && "text-icon-disabled", isComplete && !isShouldRetry && "text-success", isComplete && isShouldRetry && "text-warning", isActive && "text-white"),
                    "data-testid": !isComplete ? "activity_not_completed" : !isShouldRetry ? "activity_completed" : "activity_should_retry"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center ml-4 flex-grow-0 flex-shrink-0",
                children: [
                    type === "text" && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                        "data-testid": "materi_text",
                        as: "i",
                        color: isActive ? "inverse" : "default",
                        fontSize: "small",
                        children: "text_snippet"
                    }),
                    type === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                        "data-testid": "materi_video",
                        as: "i",
                        color: "default",
                        fontSize: "small",
                        children: "video_library"
                    }),
                    type === "quiz" && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                        "data-testid": "materi_quiz",
                        color: isActive ? "inverse" : "default",
                        as: "i",
                        fontSize: "small",
                        children: "edit"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                as: "div",
                className: "ml-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: href,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        "data-title": (0,utils_text/* toKebabCase */.mA)(name),
                        onClick: function() {
                            var ref;
                            (0,googleAnalytics/* GATrackEvent */.l)({
                                eventName: "learning_activity",
                                eventParams: {
                                    event_trigger: "click_activity_link",
                                    action_type: "choose_activity_from_materi",
                                    meta: JSON.stringify((ref = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingParams), {
                                        type: type
                                    })) !== null && ref !== void 0 ? ref : {})
                                },
                                sendDefaultParams: true
                            });
                        },
                        href: href,
                        className: (0,clsx_m/* default */.Z)("flex-grow font-semibold", isActive ? "text-white" : "text-interactive-default"),
                        children: name
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Materi_ActivityItem = (ActivityItem);

// EXTERNAL MODULE: ./utils/hooks/context/useScreenSizeContext.tsx + 1 modules
var useScreenSizeContext = __webpack_require__(65260);
;// CONCATENATED MODULE: ./assets/icons/arrow-alt-up.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowAltUp = function SvgArrowAltUp(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.5 16L12.5 9L19.5 16",
    stroke: "#52575C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var arrow_alt_up = (SvgArrowAltUp);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Materi/MateriCard.tsx
/* provided dependency */ var process = __webpack_require__(83454);















var MateriCard = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var query = param.query, id = param.id, name = param.name, quiz = param.quiz, reflective = param.reflective, _isComplete = param.isComplete, isComplete = _isComplete === void 0 ? false : _isComplete, _isShouldRetry = param.isShouldRetry, isShouldRetry = _isShouldRetry === void 0 ? false : _isShouldRetry, _isExpanded = param.isExpanded, isExpanded = _isExpanded === void 0 ? false : _isExpanded, _onClicked = param.onClicked, onClicked = _onClicked === void 0 ? function(e) {
        e.preventDefault();
    } : _onClicked, contents = param.contents;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4;
    var _$ref5 = (0,useScreenSizeContext/* useScreenSizeContext */.fl)(), isDesktopScreenSize = _$ref5.isDesktop;
    var router = (0,next_router.useRouter)();
    var _query = router.query, selectedMateriId = _query.id;
    var baseUrl = process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri";
    var toast = (0,dist_index_esm/* useToast */.pm)();
    var _$ref6 = (0,react.useState)((0,helper/* isActivityComplete */.LR)(contents, quiz)), isContentComplete = _$ref6[0], setIsContentComplete = _$ref6[1];
    (0,react.useEffect)(function() {
        setIsContentComplete((0,helper/* isActivityComplete */.LR)(contents, quiz));
    }, [
        contents,
        quiz
    ]);
    var getRecordProgressState = function(content) {
        var TYPE_DETECTION = [
            "video",
            "text"
        ];
        var PROGRESS_FLAG = [
            "COMPLETED"
        ];
        var isProgressShouldRecord = TYPE_DETECTION.includes(content.type);
        var isTypeShouldRecord = PROGRESS_FLAG.includes(content.progress);
        return !(isProgressShouldRecord && isTypeShouldRecord);
    };
    var _modul_name;
    // we have to pre-build the quiz and reflective url since quiz has no id
    var quizUrl = "/".concat(baseUrl, "/quiz/").concat(id, "?") + (0,query_string/* stringify */.Pz)({
        topik: query.topik,
        modul: query.modul,
        topik_name: query.topik_name,
        modul_name: (_modul_name = query.modul_name) !== null && _modul_name !== void 0 ? _modul_name : "",
        materi_name: name,
        from: query.from,
        menuId: query.menuId
    });
    var _modul_name1;
    var reflectiveUrl = "/".concat(baseUrl, "/refleksi/").concat(id, "?") + (0,query_string/* stringify */.Pz)({
        topik: query.topik,
        modul: query.modul,
        topik_name: query.topik_name,
        modul_name: (_modul_name1 = query.modul_name) !== null && _modul_name1 !== void 0 ? _modul_name1 : "",
        materi_name: name,
        from: query.from,
        menuId: query.menuId
    });
    var isReflectiveActive = router.pathname === "/pelatihan-mandiri/refleksi/[id]" && !!reflective && selectedMateriId === String(id);
    var isQuizActive = router.pathname === "/pelatihan-mandiri/refleksi/[id]" && selectedMateriId === String(id);
    var _completed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-3 mb-3 bg-white rounded-lg border border-subdued",
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-testid": "materi-card",
                onClick: onClicked,
                className: (0,clsx_m/* default */.Z)("relative flex -mx-3 px-3 py-4 hover:cursor-pointer", isExpanded && "border-b border-subdued"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-shrink-0 flex-grow-0 w-6 h-6 bg-white rounded-full z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkNoFill/* default */.Z, {
                            className: (0,clsx_m/* default */.Z)(!isComplete && "text-icon-disabled", isComplete && isShouldRetry && "text-warning", isComplete && !isShouldRetry && "text-success"),
                            "data-testid": !isComplete ? "materi_not_completed" : isShouldRetry ? "materi_should_retry" : "materi_completed"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-grow ml-3 pr-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                variant: "heading-sm",
                                children: name
                            }),
                            isShouldRetry && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                variant: "helper-bold",
                                color: "warning",
                                style: {
                                    color: "var(--color-warning)"
                                },
                                children: "Perlu dipelajari ulang"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 flex items-center justify-center w-10 h-full focus:outline-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_alt_up, {
                            className: (0,clsx_m/* default */.Z)(isExpanded === false && "transform rotate-180")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)(isExpanded === false && "max-h-0 overflow-hidden", isExpanded && "py-4"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sub-item pb-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                    variant: "subheading",
                                    color: "subdued",
                                    className: "uppercase tracking-wide",
                                    children: "Aktivitas"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    contents.map(function(content) {
                                        var _modul_name;
                                        var materialUrl = "/".concat(baseUrl, "/").concat(content.type, "/").concat(content.id, "?") + (0,query_string/* stringify */.Pz)({
                                            modul: query.modul,
                                            topik: query.topik,
                                            materi: id,
                                            topik_name: query.topik_name,
                                            modul_name: (_modul_name = query.modul_name) !== null && _modul_name !== void 0 ? _modul_name : "",
                                            materi_name: name,
                                            from: query.from,
                                            menuId: query.menuId,
                                            recordProgress: getRecordProgressState(content)
                                        });
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Materi_ActivityItem, {
                                            name: content.name,
                                            type: content.type,
                                            href: materialUrl,
                                            isComplete: content.completed || !!content.progress && content.progress === "COMPLETED",
                                            isShouldRetry: !!content.progress && content.progress === "SHOULD_RETRY" || !content.hasOwnProperty("progress") && isShouldRetry,
                                            trackingParams: {
                                                materi_id: id,
                                                topik_id: query.topik,
                                                module_id: query.modul
                                            },
                                            isActive: selectedMateriId === String(content.id)
                                        }, content.id);
                                    }),
                                    !!(quiz === null || quiz === void 0 ? void 0 : quiz.questions) && (quiz === null || quiz === void 0 ? void 0 : (_$ref = quiz.questions) === null || _$ref === void 0 ? void 0 : _$ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Materi_ActivityItem, {
                                        name: "Latihan Pemahaman",
                                        type: "quiz",
                                        href: quizUrl,
                                        isComplete: (_completed = quiz.completed) !== null && _completed !== void 0 ? _completed : false,
                                        isShouldRetry: !!quiz.progress && quiz.progress === "SHOULD_RETRY" || !quiz.progress && isShouldRetry,
                                        trackingParams: {
                                            materi_id: id,
                                            topik_id: query.topik,
                                            module_id: query.modul
                                        },
                                        isActive: isQuizActive
                                    })
                                ]
                            })
                        ]
                    }),
                    !!reflective && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "vertical-progress-indicator sub-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                        variant: "subheading",
                                        color: "subdued",
                                        className: "uppercase tracking-wide",
                                        children: "Cerita Reflektif"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)(isDesktopScreenSize && "flex items-center w-full mb-3 last:mb-0", isDesktopScreenSize && isReflectiveActive && "bg-[#0B5FEF] p-2 rounded-lg"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(!isDesktopScreenSize ? "absolute top-12 left-1 w-6 h-4 bg-white rounded-full z-10" : "relative flex-shrink-0 flex-grow-0 flex items-center justify-center w-6 h-4 rounded-full z-10"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckmarkNoFill/* default */.Z, {
                                                width: 17,
                                                height: 16,
                                                size: "sm",
                                                className: (0,clsx_m/* default */.Z)(!(reflective === null || reflective === void 0 ? void 0 : reflective.completed) && "text-icon-disabled", !!(reflective === null || reflective === void 0 ? void 0 : reflective.completed) && "text-success", isReflectiveActive && "text-white"),
                                                "data-testid": !!(reflective === null || reflective === void 0 ? void 0 : reflective.completed) ? "reflective_done" : "reflective_not_done"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (0,clsx_m/* default */.Z)("w-full", !isDesktopScreenSize && "pl-10", isReflectiveActive && "bg-[#0B5FEF] p-2 rounded-lg"),
                                            children: [
                                                isContentComplete && !!reflective && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: reflectiveUrl,
                                                    passHref: true,
                                                    children: isDesktopScreenSize ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (0,clsx_m/* default */.Z)("flex items-center w-full mb-3 last:mb-0"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,clsx_m/* default */.Z)("flex items-center", !isReflectiveActive && "ml-4"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                                                                    "data-testid": "materi_quiz",
                                                                    color: isReflectiveActive ? "inverse" : "default",
                                                                    as: "i",
                                                                    fontSize: "small",
                                                                    children: "person"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                                                as: "div",
                                                                className: "ml-4",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: reflectiveUrl,
                                                                    className: (0,clsx_m/* default */.Z)("flex-grow font-semibold", isReflectiveActive ? "text-white" : "text-interactive-default"),
                                                                    children: "Tulis Cerita Anda"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        "data-testid": "reflective-link",
                                                        onClick: function() {
                                                            (0,googleAnalytics/* GATrackEvent */.l)({
                                                                eventName: "learning_activity",
                                                                eventParams: {
                                                                    event_trigger: "click_refleksi_box",
                                                                    action_type: !(reflective === null || reflective === void 0 ? void 0 : reflective.completed) ? "input_refleksi" : "edit_refleksi",
                                                                    meta: JSON.stringify({
                                                                        materi_id: id,
                                                                        modul_id: query.modul,
                                                                        topik_id: query.topik
                                                                    })
                                                                },
                                                                sendDefaultParams: true
                                                            });
                                                        },
                                                        href: reflectiveUrl,
                                                        className: (0,clsx_m/* default */.Z)("block p-3 w-full border rounded-lg truncate text-ellipsis", isContentComplete ? "bg-white" : "bg-surface-disabled", ((_$ref1 = reflective.answer) === null || _$ref1 === void 0 ? void 0 : _$ref1.length) > 0 && "border-default", ((_$ref2 = reflective.answer) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) === 0 && "border-interactive-focused"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                                            as: "span",
                                                            color: ((_$ref3 = reflective.answer) === null || _$ref3 === void 0 ? void 0 : _$ref3.length) > 0 ? "default" : "subdued",
                                                            children: ((_$ref4 = reflective.answer) === null || _$ref4 === void 0 ? void 0 : _$ref4.length) > 0 ? reflective.answer : "Tulis refleksi Anda disini..."
                                                        })
                                                    })
                                                }),
                                                !isContentComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "data-testid": "reflective-inaccessible",
                                                    onClick: function() {
                                                        toast({
                                                            message: "Selesaikan semua aktivitas di materi ".concat(name, " terlebih dahulu")
                                                        });
                                                    },
                                                    className: "block p-3 w-full border rounded-lg truncate text-ellipsis bg-surface-disabled border-disabled",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.x, {
                                                        as: "span",
                                                        color: "disabled",
                                                        children: reflective.answer.length > 0 ? reflective.answer : "Tulis refleksi Anda disini..."
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
});
MateriCard.displayName = "MateriCard";
/* harmony default export */ var Materi_MateriCard = (MateriCard);


/***/ }),

/***/ 9363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28058);



var ModuleDetailsPlaceholder = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                role: "alert",
                "aria-busy": "true",
                className: "px-4 min-h-[160px] bg-expressive-dark-blue",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                            width: 280,
                            height: 12,
                            className: "mb-2"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                            width: 280,
                            height: 12,
                            className: "mb-3"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center mb-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                                width: 24,
                                height: 24,
                                rounded: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                                    width: 280,
                                    height: 8
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                            width: 280,
                            height: 12,
                            noOfLines: 2,
                            className: "mb-2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-10",
                children: [
                    0,
                    1,
                    2
                ].map(function(_, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex relative p-4 w-full mx-auto mb-3 bg-white rounded border border-subdued",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                                width: 64,
                                height: 64,
                                rounded: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "ml-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                                        width: 100,
                                        height: 12,
                                        className: "mb-4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_shimmer__WEBPACK_IMPORTED_MODULE_2__/* .Shimmer */ .q, {
                                        width: 200,
                                        height: 12,
                                        noOfLines: 2,
                                        className: "mb-1"
                                    })
                                ]
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModuleDetailsPlaceholder);


/***/ }),

/***/ 54043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89004);
/* harmony import */ var _wartek_id_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21958);
/* harmony import */ var utils_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40999);
/* harmony import */ var assets_icons_arrow_alt_right_dark_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75670);








var PostTestCard = function(param) {
    var title = param.title, description = param.description, href = param.href, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? true : _isLocked, icon = param.icon, _trackStep = param.trackStep, trackStep = _trackStep === void 0 ? function() {} : _trackStep, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("flex-grow flex-shrink rounded"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
                    "relative",
                    "min-h-[70px] p-3 w-full",
                    "border border-subdued",
                    isActive ? "bg-[#0B5FEF] " : "bg-white",
                    isLocked ? "rounded-t-lg" : "rounded-lg", 
                ]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("flex items-center"),
                    children: [
                        icon,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-3",
                            children: [
                                !isLocked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: href,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        "data-step-type": (0,utils_text__WEBPACK_IMPORTED_MODULE_3__/* .toKebabCase */ .mA)(title),
                                        onClick: trackStep,
                                        href: href,
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("overlay-link block font-bold", isActive ? "text-white" : "text-type-basic-dark"),
                                        children: title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                    variant: "heading-sm",
                                    className: "overlay-link block",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pr-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                        variant: "body-sm",
                                        color: isActive ? "inverse" : "disabled",
                                        children: description
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(assets_icons_arrow_alt_right_dark_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                color: "inverse"
                            })
                        })
                    ]
                })
            }),
            isLocked && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("flex items-center px-3 py-2  rounded-b-lg", isActive ? "bg-[#0B5FEF]" : "bg-surface-neutral-default"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_icon__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .J, {
                        className: "mr-3",
                        children: "lock"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                        variant: "body-sm",
                        children: "Pelajari materi di atas terlebih dahulu"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostTestCard);


/***/ }),

/***/ 34720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ useModuleExpanderStore; }
/* harmony export */ });
/* unused harmony exports useMilMaterialTabStore, useTestingVariantStore */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4771);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33106);



var useMilMaterialTabStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set) {
    return {
        scrollRecords: [],
        openedTab: [],
        toggleOpenedTab: function(tabId) {
            set(function(state) {
                if (state.openedTab.findIndex(function(id) {
                    return id === tabId;
                }) < 0) {
                    return {
                        openedTab: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.openedTab).concat([
                            tabId
                        ])
                    };
                } else {
                    return {
                        openedTab: state.openedTab.filter(function(id) {
                            return id !== tabId;
                        })
                    };
                }
            });
        },
        setScrollPosition: function(moduleId, scrollPosition) {
            set(function(state) {
                return {
                    scrollRecords: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(state.scrollRecords.filter(function(module) {
                        return moduleId !== module.moduleId;
                    })).concat([
                        {
                            moduleId: moduleId,
                            scrollPos: scrollPosition
                        }, 
                    ])
                };
            });
        }
    };
}, {
    name: "microlearning-material-tab"
}));
var useModuleExpanderStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set) {
    return {
        lastExpandedIds: [],
        setLastExpandedIds: function(indexes) {
            set({
                lastExpandedIds: indexes
            });
        }
    };
}, {
    name: "microlearning-module-expander",
    version: 1
}));
var useTestingVariantStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_1__/* .persist */ .tJ)(function(set) {
    return {
        variant: "baseline",
        setVariant: function setVariant(value) {
            set({
                variant: value
            });
        }
    };
}, {
    name: "microlearning-test-variant",
    version: 0
}));


/***/ }),

/***/ 69384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OZ": function() { return /* binding */ AksiNyataSessionState; },
/* harmony export */   "fs": function() { return /* binding */ PostTestStatus; }
/* harmony export */ });
/* unused harmony exports AppealState, CLWidgetType */
var AksiNyataSessionState;
(function(AksiNyataSessionState) {
    AksiNyataSessionState["NotCreated"] = "NOT_CREATED";
    AksiNyataSessionState["Created"] = "CREATED";
    AksiNyataSessionState["Confirmed"] = "CONFIRMED";
    AksiNyataSessionState["Completed"] = "COMPLETED";
    AksiNyataSessionState["Undetermined"] = "UNDETERMINED";
    AksiNyataSessionState["NeedRevision"] = "NEED_REVISION";
    AksiNyataSessionState["Validated"] = "VALIDATED";
    AksiNyataSessionState["Appeal"] = "APPEAL";
})(AksiNyataSessionState || (AksiNyataSessionState = {}));
var PostTestStatus;
(function(PostTestStatus) {
    PostTestStatus["NotStarted"] = "not_started";
    PostTestStatus["Passed"] = "passed";
    PostTestStatus["NotPassed"] = "not_passed";
})(PostTestStatus || (PostTestStatus = {}));
var AppealState;
(function(AppealState) {
    AppealState["NotCreated"] = "NOT_CREATED";
    AppealState["Submitted"] = "SUBMITTED";
    AppealState["Accepted"] = "ACCEPTED";
    AppealState["Declined"] = "DECLINED";
})(AppealState || (AppealState = {}));
var CLWidgetType;
(function(CLWidgetType) {
    CLWidgetType["ExternalAssessment"] = "Assessment";
    CLWidgetType["ExternalToolkit"] = "Toolkit";
    CLWidgetType["InternalTopic"] = "Topic";
    CLWidgetType["InternalModule"] = "Module";
    CLWidgetType["InternalLearningActivity"] = "AksiNyata";
    CLWidgetType["InternalPageCard"] = "PageCard";
    CLWidgetType["StaticVideoCard"] = "VideoCard";
    CLWidgetType["StaticHeading"] = "Heading";
    CLWidgetType["StaticText"] = "Text";
    CLWidgetType["StaticButton"] = "Button";
    CLWidgetType["StaticDocument"] = "Document";
    CLWidgetType["StaticContainer"] = "Container";
    CLWidgetType["RootContentWrapper"] = "ContentWrapper";
})(CLWidgetType || (CLWidgetType = {}));


/***/ })

}]);